import { clearActionId } from './clear-action-id';
import { initStore } from './init-store';
import { processRemoteActions } from './process-remote-actions';
import { saveActionPerformedAttempt } from './save-action-performed-attempt';

export const actions = {
	processRemoteActions,
	saveActionPerformedAttempt,
	initStore,
	clearActionId,
};
export type RemoteActionsActions = typeof actions;
